// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import exposure from './directive/exposure'
Vue.directive('exposure', exposure)
Vue.config.productionTip = false
let pipe = new Vue();
Vue.prototype.pipe = pipe;

/* eslint-disable no-new */
// new Vue({
//   el: '#left-side',
//   components: { App },
//   template: '<App/>'
// })

const app = new Vue({
  render: h => {
    return h(App);
  }
});
app.$mount("#left-side");
